import { render, staticRenderFns } from "./error-server.vue?vue&type=template&id=28a51b24&scoped=true"
import script from "./error-server.vue?vue&type=script&lang=js"
export * from "./error-server.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a51b24",
  null
  
)

export default component.exports